import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function LandClearing() {
    return (
        <PageWrapper>
            <SEO title={SiteData.landClearing.metaData.title} description={SiteData.landClearing.metaData.description}/>
            <PageHeader header={SiteData.landClearing.h1} subtitle={SiteData.landClearing.subtitle}/>
            <ServicePageTemplate body={SiteData.landClearing.body}/>
        </PageWrapper>
    )
}
